import { render, staticRenderFns } from "./SettingsShopfront.vue?vue&type=template&id=2e4d323b&scoped=true&"
import script from "./SettingsShopfront.vue?vue&type=script&lang=js&"
export * from "./SettingsShopfront.vue?vue&type=script&lang=js&"
import style0 from "./SettingsShopfront.vue?vue&type=style&index=0&id=2e4d323b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e4d323b",
  null
  
)

export default component.exports